import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth, hasRole } from "./authStore";

const IS_REACT_SNAP = typeof navigator !== "undefined" && /ReactSnap/i.test(String(navigator.userAgent || ""));

export default function ProtectedRoute({ roles }) {
    const { booting, isAuthenticated, role, boot } = useAuth();
    const location = useLocation();
    const attemptedBootPathRef = React.useRef("");

    React.useEffect(() => {
        if (IS_REACT_SNAP) return;
        if (booting || isAuthenticated) return;
        if (attemptedBootPathRef.current === location.pathname) return;

        attemptedBootPathRef.current = location.pathname;
        boot();
    }, [boot, booting, isAuthenticated, location.pathname]);

    const shouldRetryBoot =
        !IS_REACT_SNAP && !booting && !isAuthenticated && attemptedBootPathRef.current !== location.pathname;

    if (booting || shouldRetryBoot) return null;

    if (!isAuthenticated) {
        return <Navigate to="/login" replace state={{ from: location.pathname }} />;
    }

    if (roles?.length && !hasRole(role, roles)) {
        return <Navigate to="/403" replace />;
    }

    return <Outlet />;
}
